import { getRandomInt } from '~/shared';

const INDICATOR_MIN = 0;
const INDICATOR_MAX = 220;

const FISHING_MIN = 20;
const FISHING_MAX = 360;

const getIndicatorDifference = (
	fishingPosition: number,
	indicatorPosition: number,
) => {
	const center = indicatorPosition + 80;
	return Math.abs(center - fishingPosition);
};

const generateRandomPosition = () => {
	return getRandomInt(INDICATOR_MIN, INDICATOR_MAX);
};

export {
	FISHING_MAX,
	FISHING_MIN,
	generateRandomPosition,
	getIndicatorDifference,
};
